var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20979 14.7206C8.20327 14.7206 9.18542 14.5077 10.0894 14.0942L12.6416 17.7102C13.0109 18.2347 13.7348 18.3593 14.2582 17.99C14.7815 17.6218 14.9073 16.898 14.538 16.3735L12.0118 12.7926C13.583 11.2904 14.3624 9.14146 14.12 6.98125C13.8764 4.82211 12.6382 2.89979 10.7713 1.78503C8.90558 0.670328 6.62635 0.4925 4.60998 1.30244C2.59245 2.11128 1.06995 3.81729 0.493432 5.91286C-0.0843056 8.00858 0.350698 10.2527 1.6693 11.9814C2.98677 13.7089 5.03591 14.7228 7.20975 14.7205L7.20979 14.7206ZM7.20979 3.12064C8.44003 3.12064 9.62042 3.61002 10.4903 4.48002C11.3601 5.35002 11.8496 6.5304 11.8496 7.7605C11.8496 8.99059 11.3603 10.1711 10.4903 11.041C9.62027 11.9108 8.43989 12.4004 7.20979 12.4004C5.9797 12.4004 4.79917 11.911 3.92931 11.041C3.05946 10.171 2.56994 8.99059 2.56994 7.7605C2.56994 6.5304 3.05931 5.34987 3.92931 4.48002C4.79931 3.61016 5.9797 3.12064 7.20979 3.12064Z",
    fill: "rgba(26, 16, 63, 1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f1c0a67bf800e9da0297f2ca72d464a0.svg";
export { ForwardRef as ReactComponent };